<template>
    <div class="wysiwyg-editor-wrapper">
        <textarea class="wysiwyg-editor" cols="30" rows="10" v-model="dataStore.project.terms"></textarea>
    </div>
</template>

<script>

import dataStore from "../../store";

import tinymce from 'tinymce/tinymce';

import 'tinymce/skins/ui/oxide/skin.min.css'

import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/table';
import 'tinymce/plugins/help';
import 'tinymce/plugins/charmap';

import 'tinymce/themes/silver'
import 'tinymce/icons/default'
import 'tinymce/models/dom'

export default {

    mounted() {

        tinymce.init({

            selector: '.wysiwyg-editor',

            init_instance_callback: (editor) => {

                editor.on('input', (input) => {

                    this.dataStore.project.terms = editor.getContent()

                });

            },
            skin: false,
            content_css : false,
            menubar: false,
            statusbar: false,
			plugins: [
				'a11ychecker', 'advlist', 'advcode', 'advtable', 'autolink', 'checklist', 'export',
				'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
				'powerpaste', 'fullscreen', 'formatpainter', 'insertdatetime', 'media', 'table', 'help', 'wordcount'
			],
			toolbar: 'undo redo | formatpainter casechange blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | removeformat | code',
            style_formats: [
                { title: 'Headings', items: [
                    { title: 'Heading 1', format: 'h1' },
                    { title: 'Heading 2', format: 'h2' },
                    { title: 'Heading 3', format: 'h3' },
                    { title: 'Heading 4', format: 'h4' },
                    { title: 'Heading 5', format: 'h5' },
                    { title: 'Heading 6', format: 'h6' }
                ]},
                { title: 'Inline', items: [
                    { title: 'Bold', format: 'bold' },
                    { title: 'Italic', format: 'italic' },
                    { title: 'Underline', format: 'underline' },
                    { title: 'Strikethrough', format: 'strikethrough' },
                    { title: 'Superscript', format: 'superscript' },
                    { title: 'Subscript', format: 'subscript' },
                    { title: 'Code', format: 'code' }
                ]},
                { title: 'Blocks', items: [
                    { title: 'Paragraph', format: 'p' },
                    { title: 'Blockquote', format: 'blockquote' },
                    { title: 'Div', format: 'div' },
                    { title: 'Pre', format: 'pre' }
                ]},
                { title: 'Align', items: [
                    { title: 'Left', format: 'alignleft' },
                    { title: 'Center', format: 'aligncenter' },
                    { title: 'Right', format: 'alignright' },
                    { title: 'Justify', format: 'alignjustify' }
                ]}
            ]
        });


    },

    data() {
        return {
            dataStore
        }
    }
};


</script>

